var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"overflow":"auto"}},[_c('div',{attrs:{"id":"main"}},[_c('p',{staticStyle:{"text-align":"center"}},[_vm._v("暂无数据")])])])
}]

export { render, staticRenderFns }